









































import Vue, { PropOptions } from 'vue';
import Encoding from 'encoding-japanese';
// import util from '@/components/util';
import ModalBase from './ModalBaseV3.vue';

// api
import API from '@/api/common';
import * as models from '@/class/models/views/setting/users';

export default Vue.extend({
  name: 'ModalCsvImport',
  components: { ModalBase },
  props: {},
  data() {
    return {
      importFile: null as any,
      historyList: [] as models.IInsertHistory[],
    };
  },
  async mounted() {
    // 取り込み履歴取得
    const api = new API();
    const res = await api.get<models.VInsertHistory>('users/csv/history');
    if (res.result) {
      this.historyList = res.data.insertHistories;
    }
  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    // インポートエリアクリック時
    onChange(event: any) {
      const files = event.target.files;
      this.importFile = files[0];
      console.log('change', files);
    },
    // インポートエリアにドラッグアンドドロップ時
    // onDrop(event: any) {
    //   // onChangeも発生するので一旦不使用
    //   const files = event.dataTransfer.files;
    //   console.log('drop', files);
    // },
    // テンプレートCSVダウンロード
    async downloadTemplate(key: string) {
      const api = new API();
      await api.post<any, any>('users/csv/template', { key });
    },
    async onClickImport() {
      let error = '';
      // 1MBを超えていたらインポートしない
      if (this.importFile.size > 1048576) { // 1MB
        error = 'ファイルサイズが1MBを超えています。';
        return;
      }

      // encoding.jsを使用して任意の文字コードでテキスト読み込み
      // 読み込みが完了したらAPIを呼び出してインポート前確認を実行
      // https://catprogram.hatenablog.com/entry/2015/04/23/171157
      const reader = new FileReader();
      reader.onload = async (e) => { // 読み込み完了時の処理
        console.log(e, reader.result);
        // 読み込んだ任意の文字コードのArrayBufferをUnicodeに変換
        const uint8View = new Uint8Array(reader.result as ArrayBuffer);
        const converted = Encoding.convert(uint8View, 'UNICODE');
        // 文字列に変換
        const csvText = Encoding.codeToString(converted);
        // console.log('csvText', csvText);
        // API通信（インポート前確認）
        const api = new API();
        await api.post<any, any>('users/csv', { file: csvText });
      };

      // ArrayBufferとして読み込み開始（この処理が終わると上の処理が実行される）
      reader.readAsArrayBuffer(this.importFile);
    },
  },
});
